<template>
  <v-expansion-panels flat accordion v-model="panel" multiple>
    <display-expansion-panel>
      <display-expansion-panel-header class="text-uppercase info--text">
        {{ generateMessage('properties_360.titles.contract_business') }}
      </display-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="d-flex">
          <div style="width: 50%" class="pa-2 font-weight-bold">
            {{ generateMessage('properties_360.titles.contract') }}:
            <custom-simple-table
              :item="property.contractual_commitment"
              i18-path="properties_360.fields.contractual_commitment"
              :table-keys="[
                'contract_reference',
                'contract_reference_name',
                'contract_startdate',
                'contract_enddate',
                'engagement_type',
                'services_type',
              ]"
            />
            <custom-simple-table
              :item="property.usage"
              i18-path="properties_360.fields.usage"
              :table-keys="['market_type']"
            />
          </div>
          <div style="width: 50%" class="pa-2 font-weight-bold">
            {{ generateMessage('properties_360.titles.business') }}:
            <custom-simple-table
              class="px-2"
              :item="property.business"
              i18-path="properties_360.fields.business"
              :table-keys="['id', 'name']"
            />
          </div>
        </div>
      </v-expansion-panel-content>
    </display-expansion-panel>
    <display-expansion-panel>
      <display-expansion-panel-header class="text-uppercase info--text">
        {{ generateMessage('properties_360.titles.property') }}
      </display-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="d-flex flex-wrap">
          <display-checkbox
            class="ma-2"
            :label="generateMessage('properties_360.fields.active_enabled')"
            :input-value="property.active_enabled"
          />
          <display-checkbox
            class="ma-2"
            :label="
              generateMessage(
                'properties_360.fields.m2m_remotemanagement_enabled'
              )
            "
            :input-value="property.m2m_remotemanagement_enabled"
          />
          <display-checkbox
            class="ma-2"
            :label="generateMessage('properties_360.fields.usage.gtb_enabled')"
            :input-value="property.usage.gtb_enabled"
          />
          <display-checkbox
            class="ma-2"
            :label="generateMessage('properties_360.fields.gmao_enabled')"
            :input-value="property.gmao_enabled"
          />
          <display-checkbox
            class="ma-2"
            :label="generateMessage('properties_360.fields.surf_plannable')"
            :input-value="property.surf_plannable"
          />
          <display-checkbox
            class="ma-2"
            :label="
              generateMessage('properties_360.fields.usage.planon_enabled')
            "
            :input-value="property.usage.planon_enabled"
          />
          <display-checkbox
            class="ma-2"
            :label="
              generateMessage(
                'properties_360.fields.contractual_commitment.preventive_ordo'
              )
            "
            :input-value="property.contractual_commitment.preventive_ordo"
          />
          <display-checkbox
            class="ma-2"
            :label="
              generateMessage(
                'properties_360.fields.contractual_commitment.request_ordo'
              )
            "
            :input-value="property.contractual_commitment.request_ordo"
          />
        </div>
        <div class="d-flex">
          <custom-simple-table
            class="pa-2"
            style="width: 50%"
            :item="property"
            i18-path="properties_360.fields"
            :table-keys="[
              'code',
              'name',
              'shortname',
              'address',
              'access_information',
              'door_code',
            ]"
          />
          <div class="pa-2" style="width: 50%">
            <custom-simple-table
              :item="property.usage"
              i18-path="properties_360.fields.usage"
              :table-keys="['purpose', 'area_m2', 'sizing_lib']"
            />
            <custom-simple-table
              :item="property"
              i18-path="properties_360.fields"
              :table-keys="['observation', 'reminder']"
            />
          </div>
        </div>
      </v-expansion-panel-content>
    </display-expansion-panel>
    <display-expansion-panel>
      <display-expansion-panel-header class="text-uppercase info--text">
        {{ generateMessage('properties_360.titles.workforce') }}
      </display-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="d-flex">
          <div style="width: 50%">
            <custom-simple-table
              class="px-2"
              :item="property"
              i18-path="properties_360.fields"
              :table-keys="[
                'mnt_responsible_technician',
                'mnt_responsible_phone',
              ]"
            />
            <custom-simple-table
              class="px-2"
              :item="usage"
              i18-path="properties_360.fields"
              :table-keys="['maintenance_hourly_account']"
            />
          </div>
          <div style="width: 50%">
            <custom-simple-table
              class="px-2"
              :item="property"
              i18-path="properties_360.fields"
              :table-keys="['mnt_resp_buddy', 'mnt_resp_buddy_phone']"
            />
            <custom-simple-table
              class="px-2"
              :item="usage"
              i18-path="properties_360.fields"
              :table-keys="['global_hourly_account']"
            />
          </div>
        </div>
      </v-expansion-panel-content>
    </display-expansion-panel>
    <display-expansion-panel>
      <display-expansion-panel-header class="text-uppercase info--text">
        {{ generateMessage('properties_360.titles.service_location') }}
      </display-expansion-panel-header>
      <v-expansion-panel-content>
        <v-data-table
          dense
          class="secondarybackground no-hover"
          no-data-text="Aucun lieu associé à cette installation"
          :headers="locationHeaders"
          :items="location"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item.adress="{ item }">
            {{ item | showAdress }}
          </template>
        </v-data-table>
      </v-expansion-panel-content>
    </display-expansion-panel>
    <display-expansion-panel>
      <display-expansion-panel-header class="text-uppercase info--text">
        {{ generateMessage('properties_360.titles.contacts') }}
      </display-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="bordered-element pa-2 mb-5">
          <div class="font-weight-bold">
            Interlocuteurs Cofely
          </div>
          <v-simple-table dense class="secondarybackground caption">
            <thead>
              <tr>
                <th></th>
                <th>Nom</th>
                <th>Téléphone</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Responsable en charge du contrat</td>
                <td>{{ property.maintenance.administrator_name }}</td>
                <td>{{ property.maintenance.administrator_phone }}</td>
                <td>{{ property.maintenance.administrator_mail }}</td>
              </tr>
              <tr>
                <td>Responsable d'équipe</td>
                <td>{{ property.maintenance.entity_in_charge_name }}</td>
                <td>{{ property.maintenance.entity_in_charge_phone }}</td>
                <td>{{ property.maintenance.entity_in_charge_mail }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>

        <div class="bordered-element pa-2">
          <div class="font-weight-bold">
            Interlocuteurs du site
          </div>
          <v-data-table
            dense
            class="secondarybackground"
            no-data-text="Aucun contact associé à cette installation"
            :headers="contactsHeaders"
            :items="contacts"
            disable-pagination
            disable-sort
            hide-default-footer
          >
            <template v-slot:item.name="{ item }">
              {{ item.gender }} {{ item.firstname }} {{ item.lastname }}
            </template>
          </v-data-table>
        </div>
      </v-expansion-panel-content>
    </display-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { generateMessage } from '@/utils/i18n';

import CustomSimpleTable from '@/components/displays/CustomSimpleTable';
import DisplayCheckbox from '@/components/displays/DisplayCheckbox';
import { mapGetters } from 'vuex';
import { formatDateToInputDate } from '@/business/utils/dates';
import DisplayExpansionPanel from '@/components/displays/panels/DisplayExpansionPanel';
import DisplayExpansionPanelHeader from '@/components/displays/panels/DisplayExpansionPanelHeader';

export default {
  name: 'GeneralInformationsTab',
  components: {
    DisplayExpansionPanelHeader,
    DisplayExpansionPanel,
    CustomSimpleTable,
    DisplayCheckbox,
  },
  computed: {
    ...mapGetters({
      property: 'properties_360/current',
      location: 'properties_360/service_location/items',
      contacts: 'properties_360/contacts/items',
    }),
    usage() {
      return (
        this.property && {
          ...this.property.usage,
          global_hourly_account: this.property.usage.global_hourly_account
            ? `${this.property.usage.global_hourly_account} Heure(s)`
            : '',
          maintenance_hourly_account: this.property.usage
            .maintenance_hourly_account
            ? `${this.property.usage.maintenance_hourly_account} Heure(s)`
            : '',
        }
      );
    },
  },
  data() {
    return {
      panel: [0, 1],
      locationHeaders: [
        { text: 'Nom', value: 'place_name' },
        { text: 'Adresse', value: 'adress' },
        { text: 'Accès', value: 'access_information' },
        { text: 'Code', value: 'door_code' },
      ].map((item) => {
        return { ...item, class: 'secondarybackground' };
      }),
      contactsHeaders: [
        { text: 'Contact', value: 'name' },
        { text: 'Fonction', value: 'function' },
        { text: 'Téléphone', value: 'phone' },
        { text: 'Adresse', value: 'adress' },
        { text: 'Observation', value: 'observation' },
      ].map((item) => {
        return { ...item, class: 'secondarybackground' };
      }),
    };
  },
  filters: {
    showAdress(item) {
      return `${
        item.location_building_name ? `${item.location_building_name}, ` : ''
      }${item.location_street_number} ${item.location_street_name} ${
        item.location_additional_address
          ? `${item.location_additional_address}, `
          : ''
      }, ${item.location_post_code} ${item.location_city}`;
    },
  },
  methods: {
    generateMessage,
    formatDateToInputDate,
  },
};
</script>

<style scoped>
@import './FRIUtils.css';
.no-hover {
  pointer-events: none;
}
</style>
